import styled from 'styled-components'
import { Checkbox, Collapse, Alert } from 'antd'
import { title, themeColor } from '@edulastic/colors'

export const DragCrad = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: ${({ noPadding }) => !noPadding && '30px'};
`

export const DragHandler = styled.div`
  width: 36px;
  cursor: move;
  text-align: center;
`

export const ReviewItemWrapper = styled.div`
  padding: 14px 16px;
  border-bottom: 1px solid #e8e8e8;
  flex-shrink: 0;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'calc(100% - 30px)')};
  background: white;

  &:first-child {
    border-top: 1px solid #e8e8e8;
  }
`

export const QuestionCheckbox = styled(Checkbox)`
  display: block;
  margin-top: 10px;
`

export const GroupCollapse = styled(Collapse)`
  &.ant-collapse {
    border: none;
    background: none;
    & > .ant-collapse-item {
      border: none;
      margin-bottom: 5px;
    }
  }
  .ant-collapse-extra {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
  }
  &.ant-collapse-icon-position-right {
    & > .ant-collapse-item {
      & > .ant-collapse-header {
        padding: 4px 16px;
        height: 50px;
        align-items: center;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        font-weight: 600;
        color: ${title};
        background: #f8f8f8;
        border: 1px solid #dfdfdf;
        border-radius: 8px;
        .ant-collapse-arrow {
          color: ${themeColor};
        }
      }
      &.ant-collapse-item-active {
        & > .ant-collapse-header {
          border-radius: 8px 8px 0px 0px;
        }
      }
      .ant-collapse-content {
        border: none;
        & > .ant-collapse-content-box {
          padding: 15px 0px;
        }
      }
    }
  }
`

export const InfoDiv = styled.div`
  display: flex;
  flex-direction: ${({ hasSections }) => (hasSections ? 'row' : 'column')};
  align-items: center;
  line-height: 16px;
  padding: 0px 10px;
  justify-content: ${({ hasSections }) => hasSections && 'space-evenly'};
  gap: ${({ hasSections }) => hasSections && '10px'};
`

export const Text = styled.div`
  font-size: 9px;
  text-transform: uppercase;
  color: ${({ color }) => color || title};
  font-weight: 600;
`

export const Count = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${({ color }) => color || title};
`

export const QuestionIndex = styled.div``

export const StyledSpinnerContainer = styled.div`
  padding: 10px;
  > div {
    position: relative;
    top: unset;
    left: unset;
    transform: unset;
  }
  .drop-area-indication {
    display: none;
  }
  .show-drop-area .drop-area-indication {
    display: flex;
  }
  .show-drop-area .space-element {
    display: none;
  }
`
export const DropAreaIndication = styled.div`
  width: 75%;
  border: 3px dashed #b4bcc4;
  justify-content: center;
  padding: 12px;
  margin: 20px auto;
  font-size: 10px;
  color: #282828;
`

export const StyledText = styled.div`
  color: grey;
  font-size: 15px;
`

export const SectionSpaceElemenet = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledWarning = styled(Alert)`
  border: 1px solid #8e6601;
  border-radius: 16px;
  color: #8e6601;
  font-weight: 600;

  & .ant-alert-message {
    color: #8e6601;
    font-weight: 600;
  }

  & .ant-alert-description ul {
    padding-left: 16px;
    margin-bottom: 0px;
  }
`
